import { PaletteMode, Components, Theme } from '@mui/material';
import { themePalette } from '../theme.palette';
import dimensions from '../dimensions';

// Define custom variant interfaces
declare module '@mui/material/Paper' {
  interface PaperPropsVariantOverrides {
    mid: true;
    midToBrand: true;
    midToWhite: true;
    inverseRaised: true;
    inverseRaisedToBrand: true;
    transparent: true;

    // Deprecated variants
    lighter: false;
    dark: false;
    darker: false;
  }
}

export const MuiCardTheme = (mode: PaletteMode): Components<Theme>['MuiCard'] => {
  const { tokens } = themePalette(mode);
  const { spacing } = dimensions;

  const commonStyles = {
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: tokens.stroke.neutral[5],
    borderRadius: spacing(1.5), // 6px
    boxShadow: 'none', // Override MUI default shadow
    overflow: 'visible',
  };

  return {
    variants: [
      // Default variant
      {
        props: { variant: 'mid' },
        style: {
          ...commonStyles,
          backgroundColor: tokens.background.neutral.mid[3],
        },
      },
      {
        props: { variant: 'midToBrand' },
        style: {
          ...commonStyles,
          backgroundColor: tokens.background.neutral.midToBrand[3],
        },
      },
      {
        props: { variant: 'midToWhite' },
        style: {
          ...commonStyles,
          backgroundColor: tokens.background.neutral.midToWhite[4],
        },
      },
      {
        props: { variant: 'inverseRaised' },
        style: {
          ...commonStyles,
          backgroundColor: tokens.background.neutral.inverse.raised[4],
        },
      },
      {
        props: { variant: 'inverseRaisedToBrand' },
        style: {
          ...commonStyles,
          backgroundColor: tokens.background.neutral.inverse.raisedToBrand[4],
        },
      },
      // Transparent variant
      {
        props: { variant: 'transparent' },
        style: {
          ...commonStyles,
          backgroundColor: 'transparent',
        },
      },
    ],
    styleOverrides: {
      root: {
        ...commonStyles,
        backgroundColor: tokens.background.neutral.mid[3],
      },
    },
  };
};
